/**
 * @author Trendrating <info@trendrating.net>
 *
 * @summary Trendrating Price Chart - reviewed code
 */

import HighchartsReact from "highcharts-react-official";
import HCMore from "highcharts/highcharts-more";
import Highcharts from "highcharts/highstock";
import {
  createRef,
  forwardRef,
  RefObject,
  useEffect,
  useImperativeHandle,
} from "react";

type ChartProps = {
  className?: string;
  options: any;
  constructorType?: string;
};

type HighchartsRef = {
  chart: Highcharts.Chart;
  container: RefObject<HTMLDivElement>;
};

HCMore(Highcharts);

/**
 * TrendratingPriceChart
 * @param {object}   displayRatio - chart ratio
 * @param {boolean}  ratings - enable rating view
 * @param {number}   firstDate - Trendrating date
 * @param {object}   functions - event listeners
 * @param {function} functions.measure - listener for measure
 * @param {function} functions.tooltip - listener for tooltip
 * @param {boolean}  historicalRating -
 * @param {string}   scale - "linear" or "logarithmic". Default "logarithmic"
 * @param {boolean}  scaleButton -
 */
export const Chart = forwardRef(
  ({ className, options, constructorType = "stockChart" }: ChartProps, ref) => {
    const chartRef = createRef<HighchartsRef>();

    useImperativeHandle(ref, () => chartRef.current!.chart);

    useEffect(() => {
      if (chartRef.current != null && chartRef.current.chart != null) {
        chartRef.current.chart.reflow();
      }
    }, [chartRef, options]);

    return (
        <HighchartsReact
          constructorType={constructorType}
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
          immutable={true}
        />
    );
  }
);
